var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "go-navbar-share" }, [
    _c("div", { staticClass: "go-container-fluid" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse go-navbar-collapse",
          attrs: { id: "navbarSupportedContent" },
        },
        [
          _c("div", { staticClass: "go-collapse-inner" }, [
            _c("div", { staticClass: "go-btn-group" }, [
              this.$route.meta.recap
                ? _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.setIsShow.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.lefttop",
                              value: { customClass: "go-tooltip" },
                              expression: "{ customClass: 'go-tooltip' }",
                              modifiers: { hover: true, lefttop: true },
                            },
                          ],
                          staticClass: "go-tooltip-area",
                          attrs: { title: _vm.$t("report.share") },
                        },
                        [_c("i", { staticClass: "go-icon-24 go-icon-share" })]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "go-dropdown-group dropdown" }, [
                this.$route.meta.recap
                  ? _c(
                      "button",
                      {
                        staticClass: "btn go-btn-icon dropdown-toggle",
                        attrs: { type: "button", "data-toggle": "dropdown" },
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.lefttop",
                                value: { customClass: "go-tooltip" },
                                expression: "{ customClass: 'go-tooltip' }",
                                modifiers: { hover: true, lefttop: true },
                              },
                            ],
                            staticClass: "go-tooltip-area",
                            attrs: { title: _vm.$t("report.download") },
                          },
                          [
                            _c("i", {
                              staticClass: "go-icon-24 go-icon-download",
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-menu" }, [
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.downloadReportAsPDF.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "go-text",
                          domProps: {
                            textContent: _vm._s(_vm.$t("report.downloadPDF")),
                          },
                        },
                        [_vm._v("PDF")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.downloadAsWord.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "go-text",
                          domProps: {
                            textContent: _vm._s(_vm.$t("report.downloadWord")),
                          },
                        },
                        [_vm._v("Word")]
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              this.$route.meta.recap
                ? _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.print.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.lefttop",
                              value: { customClass: "go-tooltip" },
                              expression: "{ customClass: 'go-tooltip' }",
                              modifiers: { hover: true, lefttop: true },
                            },
                          ],
                          staticClass: "go-tooltip-area",
                          attrs: { title: _vm.$t("report.print") },
                        },
                        [_c("i", { staticClass: "go-icon-24 go-icon-print" })]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            !_vm.isLoadingUser && !_vm.authenticated
              ? _c("ul", { staticClass: "go-navbar-nav" }, [
                  _c("li", { staticClass: "go-nav-item active" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn go-btn-primary",
                        attrs: { href: "/register" },
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("global.menu.account.signup")
                          ),
                        },
                      },
                      [_vm._v("Sign up")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "go-nav-item" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn go-btn-default",
                        attrs: { href: "/login" },
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("global.menu.account.login")
                          ),
                        },
                      },
                      [_vm._v("Sign in")]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-navbar-header" }, [
      _c("div", { staticClass: "go-navbar-brand" }, [
        _c("a", { staticClass: "go-brand-logo", attrs: { href: "#" } }, [
          _c("img", {
            attrs: {
              src: "content/images/images_v3/common/go-goover-logo.png",
              alt: "goover",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "go-navbar-toggler",
          attrs: {
            type: "button",
            "data-toggle": "collapse",
            "data-target": "#navbarSupportedContent",
            "aria-controls": "navbarSupportedContent",
            "aria-expanded": "false",
            "aria-label": "Toggle navigation",
          },
        },
        [_c("span", { staticClass: "go-navbar-toggler-icon" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "go-icon-20" }, [
      _c("img", {
        attrs: {
          src: "content/images/images_v3/common/go-icon-document/file-pdf-fill.svg",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "go-icon-20" }, [
      _c("img", {
        attrs: {
          src: "content/images/images_v3/common/go-icon-document/file-word-fill.svg",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }